module.exports = __webpack_public_path__ + "img/bws-logo.1f0004fc.svg";